import { FC, useState } from 'react';
import { RootState } from 'js/store/reducer';

import classNames from 'classnames';

import MessageForUser from 'js/components/MessageForUser';

import t from 'js/utils/translate';
import ShowMoreButton from 'js/components/ShowMoreButton';
import { useAppSelector } from 'js/utils/hooks';

import './index.sass';

const BulkOrderInfo: FC = () => {
  const isDesktop = useAppSelector((state: RootState) => state.mediaDevice?.isDesktop);
  const [showMore, toggleShowMore] = useState(isDesktop);

  return (
    <MessageForUser variant='info' className={classNames('new-bulk-order-info')}>
      <div>
        <div className='info__top-text'>{t('new.bulkOrder.info.about')}</div>
        {showMore && (
          <>
            <div className='info__list'>
              <ol>
                <li>{t('new.bulkOrder.info.fill.and.upload')}</li>
                <li>{t('new.bulkOrder.info.option.coverage.check')}</li>
                <li>{t('new.bulkOrder.info.option.generate.labels')}</li>
                <ol>
                  <li>{t('new.bulkOrder.info.option.generate.labels.approve')}</li>
                  <li>{t('new.bulkOrder.info.option.generate.labels.cancel')}</li>
                </ol>
              </ol>
            </div>
            <div className='info__bottom-text'>
              {`${t('new.bulkOrder.info.read.more')} `}
              <a href='https://jira-di.atlassian.net/wiki/spaces/DIPUB/pages/91295644/DI+Flow+bulk+order'>
                {t('general.here')}
              </a>
            </div>
          </>
        )}
      </div>
      {!isDesktop && (
        <ShowMoreButton
          hideText={t('new.bulkOrder.info.hide')}
          showText={t('new.bulkOrder.info.show')}
          show={showMore}
          toggleShow={toggleShowMore}
        />
      )}
    </MessageForUser>
  );
};

export default BulkOrderInfo;
